(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('popup-bienvenida10');
    if (!overlay) return;

    var CLOSED_KEY = 'br10_closed';
    var SUBSCRIBED_KEY = 'br10_subscribed';

    function open() {
      overlay.classList.add('popup10-open');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function close() {
      overlay.classList.remove('popup10-open');
      overlay.setAttribute('aria-hidden', 'true');
      try {
        localStorage.setItem(CLOSED_KEY, '1');
      } catch (e) {}
    }

    /* --- Deteccion de envio correcto por JS en lugar de depender solo
       de form.posted_successfully? en Liquid. Esta pagina tiene mas de
       un formulario de tipo "customer" (este popup y el de newsletter
       del pie de pagina), y tras comprobarlo, Shopify no siempre marca
       el formulario del popup como "posted_successfully" aunque el
       envio se haya procesado correctamente (el cliente SI se crea).
       Por eso, ademas de la condicion de Liquid, comprobamos aqui si la
       URL indica que se acaba de completar un envio de tipo customer
       (?customer_posted=true) y, si es asi, forzamos el estado de
       exito nosotros mismos. */
    var justPosted = /[?&]customer_posted=true\b/.test(window.location.search);

    var forcedOpen = overlay.classList.contains('popup10-force-open') || justPosted;

    if (justPosted) {
      overlay.classList.add('popup10-force-open', 'popup10-show-success');
      /* Limpiamos el parametro de la URL para que un refresco de la
         pagina no vuelva a abrir el popup en modo exito. */
      try {
        window.history.replaceState(null, '', window.location.pathname);
      } catch (e) {}
      window.scrollTo(0, 0);
    }

    if (forcedOpen) {
      try {
        localStorage.setItem(SUBSCRIBED_KEY, '1');
      } catch (e) {}
      open();
    } else {
      var alreadyClosed = false;
      var alreadySubscribed = false;
      try {
        alreadyClosed = localStorage.getItem(CLOSED_KEY) === '1';
        alreadySubscribed = localStorage.getItem(SUBSCRIBED_KEY) === '1';
      } catch (e) {}

      if (!alreadyClosed && !alreadySubscribed) {
        var delay = parseFloat(overlay.getAttribute('data-delay') || '4') * 1000;
        window.setTimeout(open, delay);
      }
    }

    var closeBtn = overlay.querySelector('.popup10-close');
    var noThanksBtn = overlay.querySelector('.popup10-nothanks');
    var continueBtn = overlay.querySelector('.popup10-continue');
    var copyBtn = overlay.querySelector('.popup10-copy');
    var codeText = overlay.querySelector('.popup10-code');

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (noThanksBtn) noThanksBtn.addEventListener('click', close);
    if (continueBtn) continueBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('popup10-open')) close();
    });

    if (copyBtn && codeText) {
      copyBtn.addEventListener('click', function () {
        var value = codeText.textContent.trim();
        var done = function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copiado';
          window.setTimeout(function () {
            copyBtn.textContent = original;
          }, 1800);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done).catch(function () {
            fallbackCopy(value, done);
          });
        } else {
          fallbackCopy(value, done);
        }
      });
    }

    function fallbackCopy(value, done) {
      var input = document.createElement('textarea');
      input.value = value;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
      } catch (e) {}
      document.body.removeChild(input);
      done();
    }
  });
})();
